export enum ServiceType {
  ENTERPRISE = 'ENTERPRISE',
  API = 'API',
  UPGRADE_PRICING_ACCESS = 'UpgradePricingAccess',
  BONDSCREENER_EXPORT = 'BondscreenerExport',
}
